// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-setup-webhook-content{margin-top:8px;width:100%;height:auto;border:1px solid #c3c3c3;border-radius:3px;padding:24px;background:#fff;text-align:initial}.cvat-create-webhook-page{width:100%;height:100%;padding-top:40px}", ""]);
// Exports
module.exports = exports;
